import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Eye, EyeOff, LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export const PasswordInput = ({ id, testId, value, onChange, placeholder = "••••••••", minLength = 8, autoComplete }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input id={id} data-testid={testId} type={show ? "text" : "password"} required minLength={minLength}
        value={value} onChange={onChange} placeholder={placeholder} autoComplete={autoComplete} className="pr-11" />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
        data-testid={`${testId}-toggle`}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};

export const LoginForm = ({ onSuccess }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`¡Hola de nuevo, ${u.name?.split(" ")[0] || ""}!`);
      onSuccess?.(u);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="customer-login-form">
      <div className="space-y-2">
        <Label htmlFor="login-email">Correo electrónico</Label>
        <Input id="login-email" data-testid="customer-login-email-input" type="email" required autoComplete="email"
          value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" />
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="login-password">Contraseña</Label>
          <Link to="/cuenta/recuperar" data-testid="forgot-password-link" className="text-xs text-cyan-700 hover:text-cyan-800 underline underline-offset-2">
            ¿Olvidaste tu contraseña?
          </Link>
        </div>
        <PasswordInput id="login-password" testId="customer-login-password-input" value={password} minLength={1}
          onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
      </div>
      <Button type="submit" disabled={loading} data-testid="customer-login-submit-btn"
        className="w-full h-11 rounded-full bg-cyan-500 hover:bg-cyan-600">
        <LogIn className="h-4 w-4 mr-2" /> {loading ? "Entrando..." : "Entrar"}
      </Button>
    </form>
  );
};
